import React, { useState } from "react";
import { useI18n } from "@/i18n/I18nContext";
import { IMAGES } from "@/data/site";
import { Reveal } from "@/components/Reveal";
import { Lightbox } from "@/components/Lightbox";
import { Heart, MapPin, Coffee, Star } from "lucide-react";

export default function AboutPage() {
  const { t } = useI18n();
  const values = t("about.values");
  const story = t("about.story");
  const gallery = IMAGES.aboutGallery;
  const icons = [Heart, MapPin, Coffee];
  const [lbIndex, setLbIndex] = useState(null);

  return (
    <>
      <section className="pt-36 pb-12 bg-[#F2EFEB]">
        <div className="max-w-5xl mx-auto px-6 md:px-12">
          <Reveal>
            <div className="text-xs uppercase tracking-[0.3em] text-[#345B73] mb-4">Famiglia · Bellagio</div>
            <h1 className="font-display text-5xl md:text-6xl text-[#1A1A1A] tracking-tight">{t("about.title")}</h1>
            <p className="mt-6 max-w-3xl text-xl md:text-2xl text-[#1A1A1A] font-display leading-snug">{t("about.lead")}</p>
          </Reveal>
        </div>
      </section>

      <section className="py-20 md:py-28">
        <div className="max-w-6xl mx-auto px-6 md:px-12 grid lg:grid-cols-2 gap-12 lg:gap-16 items-center">
          <Reveal>
            <div className="grid grid-cols-2 gap-3 md:gap-4">
              {gallery.map((src, i) => (
                <button type="button" key={i} onClick={() => setLbIndex(i)}
                  data-testid={`about-photo-${i}`}
                  className="aspect-square overflow-hidden rounded-2xl relative group cursor-pointer">
                  <img src={src} alt="I Lake It Bellagio" className="w-full h-full object-cover img-zoom" />
                </button>
              ))}
            </div>
          </Reveal>
          <Reveal delay={150}>
            <div className="space-y-5">
              {story.map((p, i) => (
                <p key={i} className="text-[#5C5C5C] text-base md:text-lg leading-relaxed">{p}</p>
              ))}
            </div>
          </Reveal>
        </div>
      </section>

      <section className="py-20 md:py-24 bg-[#1D3557]">
        <div className="max-w-4xl mx-auto px-6 md:px-12 text-center">
          <Reveal>
            <Heart className="w-8 h-8 text-[#E0A458] mx-auto mb-6" />
            <h2 className="font-display text-3xl md:text-4xl text-white tracking-tight mb-6">{t("about.teamTitle")}</h2>
            <p className="text-white/85 text-lg leading-relaxed">{t("about.team")}</p>
            <p className="mt-8 font-display text-xl md:text-2xl text-[#E0A458] leading-snug">{t("about.closing")}</p>
          </Reveal>
        </div>
      </section>

      <section className="py-20 md:py-28 bg-[#FAF9F6]">
        <div className="max-w-6xl mx-auto px-6 md:px-12">
          <div className="grid md:grid-cols-3 gap-6">
            {values.map((v, i) => {
              const Icon = icons[i] || Star;
              return (
                <Reveal key={i} delay={i * 100}>
                  <div className="p-8 rounded-2xl border border-black/5 bg-white h-full">
                    <Icon className="w-8 h-8 text-[#4B6653] mb-5" />
                    <h3 className="font-display text-xl text-[#1A1A1A] mb-3">{v.t}</h3>
                    <p className="text-sm text-[#5C5C5C] leading-relaxed">{v.d}</p>
                  </div>
                </Reveal>
              );
            })}
          </div>
        </div>
      </section>

      <Lightbox images={gallery} index={lbIndex} onIndexChange={setLbIndex}
        onClose={() => setLbIndex(null)} alt="I Lake It Bellagio" />
    </>
  );
}
